import React from 'react';

import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { device } from 'helpers/screenSizes';

import DesktopView from './DesktopView';
import MobileView from './MobileView';

const MaintenanceBanner = props => {
  const { isLoggedIn, className = '', showWhatToExpect, isTopBanner } = props;
  return (
    <>
      <MediaQuery query={device.up.md}>
        <DesktopView
          className={className}
          isLoggedIn={isLoggedIn}
          showWhatToExpect={showWhatToExpect}
        />
      </MediaQuery>
      <MediaQuery query={device.down.md}>
        <MobileView isLoggedIn={isLoggedIn} isTopBanner={isTopBanner} />
      </MediaQuery>
    </>
  );
};

MaintenanceBanner.propTypes = {
  isLoggedIn: PropTypes.bool,
  className: PropTypes.string,
  showWhatToExpect: PropTypes.bool,
  isTopBanner: PropTypes.bool,
};

export default MaintenanceBanner;

// Ref code old version
// return (
//   <>
//     {!showBanner ? (
//       <Wrapper>
//         <div className="desc">
//           <TimerYellow className="timer" />
//           <MediaQuery query={device.up.md}>
//             {t('common:maintenance_notif_banner', {
//               returnObjects: true,
//               timer,
//               expectedDownTime: minutesSecondsFormat(expectedDownTimeInSec),
//             })}
//           </MediaQuery>
//           <MediaQuery query={device.down.md}>
//             {t('common:maintenance_notif_banner_mobile', {
//               returnObjects: true,
//               timer,
//               expectedDownTime: minutesSecondsFormat(expectedDownTimeInSec),
//             })}
//           </MediaQuery>
//           <span className="color-white redirect-link">
//             <a
//               href="https://www.delta.exchange/blog/support/what-to-expect-during-maintenance/"
//               target="_blank"
//               rel="noreferrer">
//               {t('common:what_to_expect')}
//               <NewRedirectIcon />
//             </a>
//           </span>
//         </div>
//         {/* Shouldn't be closed if the timer is less than 10mins */}
//         {maintenanceStartTimeInSec / 60 >= 10 && (
//           <div className="close" onClick={() => setShowBanner(false)}>
//             <CrossModalCloseIcon />
//           </div>
//         )}
//       </Wrapper>
//     ) : null}
//   </>
// );

// const expectedDownTimeInSec = unixTimeDiffInSeconds(
//   maintenance_finish_time,
//   maintenance_start_time
// );

// const [timer, updateTimer] = useState('');

// useEffect(() => {
//   const maintenanceStartTimeInSec = unixTimeDiffInSeconds(
//     maintenance_start_time
//   );
//   if (maintenanceStartTimeInSec > 0 && maintenanceStartTimeInSec / 60 <= 60*24*3) {
//     setShowBanner(true);
//     const timerId = setInterval(
//       () =>
//         updateTimer(
//           minutesSecondsFormat(unixTimeDiffInSeconds(maintenance_start_time))
//         ),
//       1000
//     );
//     return () => {
//       clearInterval(timerId);
//     };
//   } else {
//     setShowBanner(false);
//   }
// }, [maintenance_start_time]);
